import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Global safety nets: surface crashes to the console & stash the last error
// for debugging, but never tear down the UI — ErrorBoundary handles render
// errors and these handlers cover async/promise escapes.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    // eslint-disable-next-line no-console
    console.error("[unhandledrejection]", reason);
    try {
      window.__lastUnhandledRejection = {
        message: String(reason?.message || reason),
        stack: reason?.stack,
        at: new Date().toISOString(),
      };
    } catch (e) { /* noop */ }
  });

  window.addEventListener("error", (event) => {
    // eslint-disable-next-line no-console
    console.error("[window.onerror]", event?.message, event?.error);
    try {
      window.__lastWindowError = {
        message: String(event?.message || ""),
        source: event?.filename,
        line: event?.lineno,
        col: event?.colno,
        stack: event?.error?.stack,
        at: new Date().toISOString(),
      };
    } catch (e) { /* noop */ }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
